import { config } from '_config';
import { createClickBody } from '_helpers/location';
const { apiUrl } = config;

export default function Clicks(location) {
  const click = createClickBody(location);
  const { pageType } = click;

  let salePage = window.location.href;
  let salePageURLArr = salePage.split('/');
  let salePageURL = (salePageURLArr[0] + '//' + salePageURLArr[2]).replace(
    /\/+$/,
    ''
  );
  let url = apiUrl + '/clicks';
  let fallbackUrl = `${salePageURL}/crm` + '/clicks';

  fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(click),
  })
    .then((res) => res.json())
    .then((res) => {
      if (res.error) {
        throw res.error;
      }
      if (res.crmSessionId && pageType !== 'thankyouPage') {
        try {
          localStorage.setItem('crmSessionId', res.crmSessionId);
        } catch (error) {}
      }
      if (pageType === 'thankyouPage') {
        if (localStorage && localStorage.getItem('crmSessionId')) {
          localStorage.removeItem('crmSessionId');
        }
      }
    })
    .catch((error) => {
      if (error.request) {
        fetch(fallbackUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(click),
        })
          .then((res) => res.json())
          .then((res) => {
            if (res.error) {
              throw res.error;
            }
            if (res.crmSessionId && pageType !== 'thankyouPage') {
              try {
                localStorage.setItem('crmSessionId', res.crmSessionId);
              } catch (error) {}
            }
            if (pageType === 'thankyouPage') {
              if (localStorage && localStorage.getItem('crmSessionId')) {
                localStorage.removeItem('crmSessionId');
              }
            }
          })
          .catch((error) => {
            console.log(error);
          });
      } else {
        console.log(error);
      }
    });
}
